import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    CircularProgress,
    List,
    ListItem,
    ListItemText,
} from '@mui/material';
import useAuthenticatedData from '../../hooks/useAuthenticatedData';
import config from '../../config';

export const MembershipCompanyWidePopup = ({ open, onClose }) => {


    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Who is Included?</DialogTitle>
            <DialogContent dividers>
                <List dense sx={{
                    '& .MuiListItem-root': {
                        '&::before': {
                            content: '"•"',
                            color: '#ffffff',
                            display: 'inline-block',
                            width: '1em',
                            marginLeft: '-1em'
                        }
                    }
                }}>
                    This includes all activity in the company, regardless of team membership. Clicking on a metric will drill down and you can see how the sales team contributed vs. the rest of the company.
                </List>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} size="small" sx={{ color: '#ffffff' }}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default MembershipCompanyWidePopup;